import remove from 'lodash/remove';
import {
  fetchSavedAuditions,
  fetchNdaAcceptance,
  acceptNdaAction,
  saveAuditionAction,
  unsaveAuditionAction,
  applyToAudition,
} from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const saveAudition = createAsyncThunk(
  'auditionsTalents/saveAudition',
  async ({ talentId, auditionId }) =>
    await saveAuditionAction(talentId, auditionId),
);

export const unsaveAudition = createAsyncThunk(
  'auditionsTalents/unsaveAudition',
  async ({ talentId, auditionId }) =>
    await unsaveAuditionAction(talentId, auditionId),
);

export const loadSavedAuditions = createAsyncThunk(
  'auditionsTalents/saved',
  async talentId => await fetchSavedAuditions(talentId),
);

export const loadNdaAcceptance = createAsyncThunk(
  'auditionsTalents/fetchNda',
  async auditionId => await fetchNdaAcceptance(auditionId),
);

export const acceptNda = createAsyncThunk(
  'auditionsTalents/acceptNda',
  async auditionId => await acceptNdaAction(auditionId),
);

export const apply = applyToAudition;

const auditionsTalentsSlice = createSlice({
  name: 'auditionsTalents',
  initialState: {
    savedAuditions: [],
    loadingSavedAuditions: false,
  },
  extraReducers: builder => {
    builder
      .addCase(loadSavedAuditions.pending, (state, _) => {
        state.loadingSavedAuditions = true;
      })
      .addCase(loadSavedAuditions.fulfilled, (state, action) => {
        state.loadingSavedAuditions = false;
        state.savedAuditions = action.payload.data;
      })
      .addCase(loadSavedAuditions.rejected, (state, _) => {
        state.loadingSavedAuditions = false;
      })
      .addCase(saveAudition.pending, (state, _) => {
        state.loadingSavedAuditions = true;
      })
      .addCase(saveAudition.fulfilled, (state, action) => {
        state.loadingSavedAuditions = false;
        // TODO: verify whether this is true
        // TODO: It's not working, cause we don't get an audition in the payload
        // Backend has got a task for this: AHAB-719
        state.savedAuditions = [...state.savedAuditions, action.payload.data];
      })
      .addCase(saveAudition.rejected, (state, _) => {
        state.loadingSavedAuditions = false;
      })
      .addCase(unsaveAudition.pending, (state, _) => {
        state.loadingSavedAuditions = true;
      })
      .addCase(unsaveAudition.fulfilled, (state, action) => {
        const auditionId = action.meta.arg.auditionId;
        state.loadingSavedAuditions = false;
        remove(state.savedAuditions, audition => audition.id === auditionId);
      })
      .addCase(unsaveAudition.rejected, (state, _) => {
        state.loadingSavedAuditions = false;
      });
  },
  selectors: {
    getSavedAuditions: state => state.savedAuditions,
    getLoadingSavedAuditions: state => state.loadingSavedAuditions,
  },
});

export const reducer = auditionsTalentsSlice.reducer;
export const {
  getSavedAuditions,
  getLoadingSavedAuditions,
} = auditionsTalentsSlice.selectors;
